import { render } from "./categoryView.vue?vue&type=template&id=6ea868d3"
import script from "./categoryView.vue?vue&type=script&lang=js"
export * from "./categoryView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__